module.exports = __webpack_public_path__ + "img/research-soho-retail-group.4b9ad778.png";